import { COUNTRY_CODES } from 'swag-common/constants/shipping.constants';
const checkIsReceiverDomestic = receiver => receiver.country === COUNTRY_CODES.US;
export default checkIsReceiverDomestic;